/* eslint-disable multiline-ternary */
import React, { memo, useEffect, useState } from 'react'
import { useGlobalState } from '../providers/GlobalState'
import { useParams } from 'react-router-dom'
import Properties from '../component/IOL/Properties'
import { IolLibrary } from '../types/graphql'
import {
  animationAppTransitions,
  animationAppVariants
} from '../component/Helpers/pageAnimation'
import { motion } from 'framer-motion'
import SimulationsButton from '../component/SimulationsButton'
import IolLibSlug from '../component/IOL/IolLib-slug'
import { useEditMode } from '../providers/EditMode'

interface ParamTypes {
  libId: string
}

type Option = { name: string; url: string; active?: boolean }

// IOL LIB PAGE
const LentePage: React.FC = () => {
  const [activeIol, setActiveIol] = useState<IolLibrary | null | undefined>()
  const [options, setOptions] = useState<Option[]>([])
  const { libId } = useParams<ParamTypes>()
  const [url, setUrl] = useState<string>('thumb')
  const { editMode } = useEditMode()
  const { iolLibraries } = useGlobalState()

  const handleChange = (url: string) => {
    setUrl(url)
  }

  useEffect(() => {
    if (iolLibraries) {
      setActiveIol(iolLibraries.find(x => x?.slug === libId))
    }
  }, [libId, iolLibraries])

  useEffect(() => {
    if (activeIol) {
      setOptions([
        {
          name: 'Informativo',
          url: 'thumb',
          active: true
        },
        {
          name: '3D',
          url: 'iframe',
          active: !!activeIol.iframe
        }
      ])
    }
  }, [activeIol])

  const Page: React.FC = () => {
    return (
      <motion.div
        initial="initial"
        animate="in"
        exit="out"
        variants={animationAppVariants}
        transition={animationAppTransitions}
        style={{
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '83vh',
          margin: 'auto',
          overflow: 'hidden'
        }}
      >
        <div
          style={{
            position: 'relative',
            overflow: 'hidden',
            width: '100%',
            paddingTop: '56.25%'
          }}
        >
          {url === 'iframe' ? (
            <iframe
              src={activeIol?.iframe || ''}
              title={activeIol?.name}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                width: '100%',
                height: '100%'
              }}
            />
          ) : (
            <img
              src={activeIol?.thumb}
              alt={activeIol?.name}
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                width: '100%',
                height: '100%'
              }}
            />
          )}
        </div>
      </motion.div>
    )
  }

  return (
    <div
      style={{
        height: '100vh',
        background: 'linear-gradient(180deg, #666666 0%, #8F8F8F 143.29%)'
      }}
    >
      {editMode && <IolLibSlug />}
      <Page />
      {activeIol && <Properties properties={activeIol.properties} />}
      {activeIol && options[0] && (
        <SimulationsButton
          handleScenarioChange={handleChange}
          options={options}
          activeUrl={url}
        />
      )}
    </div>
  )
}

export default memo(LentePage)
